import './blog_single.scss';
import './img/news-item.jpg';


// WEBPACK FOOTER //
// ./resources/views/partials/blog_type/single/blog_single.js